import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.background};
  padding: 20px;
`

export const Content = styled.div`
  background-color: ${({ theme }) => theme.colors.secondary};
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 30px;
  width: 100%;
  max-width: 600px;
`

export const Header = styled.div`
  text-align: center;
  margin-bottom: 25px;
  border-bottom: 2px solid ${({ theme }) => theme.colors.border};
  padding-bottom: 15px;

  h2 {
    color: ${({ theme }) => theme.colors.primary};
    margin: 0 0 10px 0;
  }
  
  p {
    color: ${({ theme }) => theme.colors.text};
    margin: 0;
    font-size: 14px;
  }
`

export const InfoSection = styled.div`
  margin-bottom: 20px;

  h3 {
    color: ${({ theme }) => theme.colors.primary};
    margin: 0 0 10px 0;
    font-size: 16px;
  }
`

export const InfoRow = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;

  strong {
    font-size: 12px;
    color: ${({ theme }) => theme.colors.text};
    opacity: 0.8;
    margin-bottom: 4px;
  }

  span {
    font-size: 15px;
    color: ${({ theme }) => theme.colors.text};
    font-weight: 500;
  }
`

export const ActionButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.primary};
  color: white;
  text-decoration: none;
  padding: 12px 20px;
  border-radius: 8px;
  font-weight: bold;
  margin-top: 30px;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }
`
